import { useState, useEffect } from "react";
import axios from "axios";
import { Calendar, List, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PageHero } from "@/components/Ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtDate = (d) => new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" });

const Scadenziario = () => {
  const [items, setItems] = useState([]);
  const [view, setView] = useState("list");
  const [stato, setStato] = useState("tutti");

  useEffect(() => { axios.get(`${API}/deadlines`).then((r) => setItems(r.data)); }, []);

  const filtered = items.filter((i) => stato === "tutti" || i.stato === stato);
  const cats = [...new Set(items.map((i) => i.categoria))];

  return (
    <div data-testid="scadenziario-page">
      <PageHero eyebrow="Scadenziario" title="Le principali scadenze scolastiche" subtitle="Tieni sotto controllo tutte le date importanti: GPS, mobilità, concorsi, assegnazioni e immissioni in ruolo." />

      <section className="bg-white py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <div className="flex flex-wrap items-center justify-between gap-4 mb-10">
            <div className="flex gap-2" data-testid="scadenziario-view-toggle">
              <button onClick={() => setView("list")} className={`inline-flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.1em] font-bold border transition-colors ${view === "list" ? "bg-navy-900 text-white border-navy-900" : "border-gray-200 text-navy-900 hover:border-gold-500"}`}><List className="w-4 h-4" /> Elenco</button>
              <button onClick={() => setView("cat")} className={`inline-flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.1em] font-bold border transition-colors ${view === "cat" ? "bg-navy-900 text-white border-navy-900" : "border-gray-200 text-navy-900 hover:border-gold-500"}`}><Calendar className="w-4 h-4" /> Per categoria</button>
            </div>
            <div className="flex gap-2">
              {["tutti", "aperto", "chiuso"].map((s) => (
                <button key={s} onClick={() => setStato(s)} data-testid={`filter-stato-${s}`} className={`px-4 py-2 text-xs uppercase tracking-[0.1em] font-bold border transition-colors ${stato === s ? "bg-gold-500 text-navy-900 border-gold-500" : "border-gray-200 text-navy-900 hover:border-gold-500"}`}>{s}</button>
              ))}
            </div>
          </div>

          {view === "list" ? (
            <div className="space-y-4" data-testid="scadenziario-list">
              {filtered.map((d) => (
                <div key={d.id} data-testid={`deadline-${d.id}`} className="flex flex-col md:flex-row md:items-center gap-4 border border-gray-100 shadow-crisp p-6 hover:border-gold-500 transition-colors">
                  <div className="flex items-center gap-4 md:w-64 shrink-0">
                    <div className="w-14 h-14 bg-navy-900 flex flex-col items-center justify-center shrink-0 text-white">
                      <Clock className="w-5 h-5 text-gold-500" />
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-[0.1em] font-bold text-gold-600">{d.categoria}</div>
                      <div className="text-sm font-semibold text-navy-900">{fmtDate(d.data)}</div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-serif text-xl font-semibold text-navy-900">{d.titolo}</h3>
                    <p className="text-sm text-slate-600 mt-1">{d.descrizione}</p>
                  </div>
                  <span className={`px-3 py-1 text-xs font-bold uppercase tracking-[0.1em] shrink-0 ${d.stato === "aperto" ? "bg-emerald-100 text-emerald-800" : "bg-rose-100 text-rose-800"}`}>{d.stato}</span>
                </div>
              ))}
              {filtered.length === 0 && <p className="text-slate-500">Nessuna scadenza per il filtro selezionato.</p>}
            </div>
          ) : (
            <div className="space-y-10" data-testid="scadenziario-cat">
              {cats.map((c) => {
                const list = filtered.filter((i) => i.categoria === c);
                if (list.length === 0) return null;
                return (
                  <div key={c}>
                    <h3 className="font-serif text-2xl font-semibold text-navy-900 border-b border-gray-200 pb-3 mb-4">{c}</h3>
                    <div className="grid sm:grid-cols-2 gap-4">
                      {list.map((d) => (
                        <div key={d.id} className="border border-gray-100 shadow-crisp p-5">
                          <div className="flex items-center justify-between"><span className="text-sm font-semibold text-navy-900">{fmtDate(d.data)}</span><span className={`px-2 py-0.5 text-xs font-bold uppercase ${d.stato === "aperto" ? "bg-emerald-100 text-emerald-800" : "bg-rose-100 text-rose-800"}`}>{d.stato}</span></div>
                          <div className="mt-2 font-serif text-lg font-semibold text-navy-900">{d.titolo}</div>
                          <p className="text-sm text-slate-600 mt-1">{d.descrizione}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="mt-12 bg-navy-900 p-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="font-serif text-2xl text-white">Non perdere nessuna scadenza importante.</p>
            <Link to="/prenota" className="inline-flex items-center gap-2 bg-gold-500 text-navy-900 font-bold text-sm uppercase tracking-[0.1em] px-8 py-4 hover:bg-gold-400 transition-colors">Prenota consulenza <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Scadenziario;
